import type { LoginType } from '../../auth/models/auth.model';
import type { Video } from './video.interface';

export interface AccessResponse {
  id: string;
  authenticated: boolean;
  loginTypes: LoginType[];
  availabilityResponse: ContentAvailabilityResponseType;
  denialReason: DenialReason;
  accessResponse: GatedAccessResponseType;
  /** Caller's public IP as seen by the backend; feeds Mux Data session metadata. */
  clientIp?: string | null;
}

export interface VideoAccessResponse extends AccessResponse {
  content: Video;
}

export interface VideoListAccessResponse extends AccessResponse {
  content: Video[];
}

export enum ContentAvailabilityResponseType {
  GATED = 'GATED',
  GEO_RESTRICTED = 'GEO_RESTRICTED',
  INVENTORY_RESTRICTED = 'INVENTORY_RESTRICTED',
  UNRESTRICTED = 'UNRESTRICTED',
  UNPUBLISHED = 'UNPUBLISHED',
}

export enum GatedAccessResponseType {
  ACCESS_GRANTED = 'ACCESS_GRANTED',
  ACCESS_DENIED = 'ACCESS_DENIED',
  REQUEST_LOGIN = 'REQUEST_LOGIN',
}

export enum DenialReason {
  INSUFFICIENT_USES_AVAILABLE = 'INSUFFICIENT_USES_AVAILABLE',
  NO_KEY_FOUND = 'NO_KEY_FOUND',
  CURRENTLY_UNAVAILABLE = 'CURRENTLY_UNAVAILABLE',
  ACCESS_EXPIRED = 'ACCESS_EXPIRED',
  GEO_RESTRICTED = 'GEO_RESTRICTED',
  SOLD_OUT = 'SOLD_OUT',
  UNKNOWN = 'UNKNOWN',
}
